/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */
import {
  VideoLibrary,
  Assignment,
  NoteAdd,
  MoneyOff,
} from "@material-ui/icons";

import {
  sEnrollN,
  sEnrollMsg,
  sClassroom,
  sClassroomMsg,
  sClipbrd,
  sClipbrdMsg,
  sNotes,
  sNotesMsg,
  sWhoS,
  sWhoN,
  sWhoI,
} from "assets/jss/views/ResStrings";

export type ContentDataType = {
  title: string;
  content: string;
  image?: string;
  color?: string; // optional
  icon?: React.ReactNode;
};

// for section "What" (aka "Why")
const whatSectionImages: string[] = [
  require("assets/img/students1.jpg"),
  require("assets/img/nurse1.jpg"),
  require("assets/img/teacher1.jpg"),
];

export const whyContent: ContentDataType[] = [
  {
    title: `Nursing Students`,
    content: sWhoS,
    image: whatSectionImages[0],
    color: "#C47E2D",
  },
  {
    title: `Nurses`,
    content: sWhoN,
    image: whatSectionImages[1],
    color: "#638C38",
  },
  {
    title: `Nursing Instructors`,
    content: sWhoI,
    image: whatSectionImages[2],
    color: "#b22222",
  },
];

export const howContent: ContentDataType[] = [
  {
    icon: MoneyOff,
    title: sEnrollN, // "Free Enroll"
    content: sEnrollMsg,
  },
  {
    icon: VideoLibrary,
    title: sClassroom,
    content: sClassroomMsg,
  },
  {
    icon: Assignment,
    title: sClipbrd,
    content: sClipbrdMsg,
  },
  {
    icon: NoteAdd,
    title: sNotes,
    content: sNotesMsg,
  },
];
